import type { PieSeriesOption } from 'echarts';

import type { SpendingPlanGraphConfig, SpendingPlanGraphDatum } from './types';

export const buildSpendingPlanGraphSeries = (
  data: SpendingPlanGraphDatum[],
  config: SpendingPlanGraphConfig,
): PieSeriesOption => ({
  type: 'pie',
  radius: ['40%', '94%'],
  center: ['50%', '50%'],
  avoidLabelOverlap: false,
  cursor: 'pointer',
  label: { show: false },
  labelLine: { show: false },
  selectedMode: config.zeroState ? false : 'single',
  // AMCharts enlarged the selected segment without translating it away from its neighbours.
  selectedOffset: 0,
  itemStyle: {
    borderColor: config.theme.bgColor,
    borderRadius: 1,
    borderWidth: 1,
  },
  emphasis: { scale: false },
  data: data.map((datum, index) => ({
    name: datum.name,
    value: datum.value,
    selected: !config.zeroState && index === config.selectedIndex,
    itemStyle: { color: datum.color },
  })),
});
